/**
 * Header: solid background once scrolled, mobile menu, "back to top" button.
 */
(() => {
	const header = document.querySelector('[data-header]');
	const toggle = document.querySelector('[data-nav-toggle]');
	const nav = document.querySelector('[data-nav]');
	const toTop = document.querySelector('[data-to-top]');

	// Scroll state (IntersectionObserver on a sentinel: no scroll listener).
	const sentinel = document.createElement('div');
	sentinel.setAttribute('aria-hidden', 'true');
	sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:80px;pointer-events:none;';
	document.body.prepend(sentinel);

	const topSentinel = document.createElement('div');
	topSentinel.setAttribute('aria-hidden', 'true');
	topSentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:100vh;pointer-events:none;';
	document.body.prepend(topSentinel);

	if ('IntersectionObserver' in window) {
		new IntersectionObserver(([entry]) => {
			header?.classList.toggle('is-scrolled', !entry.isIntersecting);
		}).observe(sentinel);

		new IntersectionObserver(([entry]) => {
			toTop?.classList.toggle('is-visible', !entry.isIntersecting);
		}).observe(topSentinel);
	} else {
		header?.classList.add('is-scrolled');
	}

	// Mobile menu
	if (!toggle || !nav) {
		return;
	}

	const setOpen = (open) => {
		toggle.setAttribute('aria-expanded', String(open));
		document.body.classList.toggle('nav-open', open);
	};

	toggle.addEventListener('click', () => {
		setOpen(toggle.getAttribute('aria-expanded') !== 'true');
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
			setOpen(false);
			toggle.focus();
		}
	});

	nav.addEventListener('click', (e) => {
		if (e.target.closest('a')) {
			setOpen(false);
		}
	});

	matchMedia('(min-width: 900px)').addEventListener('change', (e) => {
		if (e.matches) {
			setOpen(false);
		}
	});
})();
